{
  "help": {
    "title": "How can we help, {firstName}?",
    "onboarding": {
      "install": {
        "title": "Install SparkLayer for me",
        "body": "Our expert team can help integrate SparkLayer onto your website. It typically takes less than 1 working day.",
        "action": "Get started"
      },
      "book_call": {
        "title": "Book a free onboarding call",
        "body": "Our expert team is here to help! Book a call and we'll guide you through setting up SparkLayer and launching.",
        "action": "Book a call"
      }
    },
    "help_grid": {
      "documentation_and_features": {
        "title": "Documentation & Features",
        "body": "Our documentation provides guides on how to install and configure SparkLayer, as well as how the front-end features work."
      },
      "technical_support": {
        "title": "Technical Support",
        "body": "For technical questions, contact our support team. We aim to respond within one working day."
      },
      "book_call": {
        "title": "Book an Onboarding Call",
        "body": "We're here to help! Book a call with one of our experts to walk through how to integrate and customise SparkLayer."
      },
      "general_questions": {
        "title": "General Questions",
        "body": "For general questions, partner and press enquiries, you can email our team directly."
      }
    },
    "partner_actions": {
      "title": "Partner program",
      "body": "If you run an agency and you think SparkLayer could be a good fit for your customers, you can register as an official partner.",
      "affiliate_sign_up": "Sign up to our affiliate program",
      "partner_apply": "Apply to become a partner"
    }
  },
  "help_partner": {
    "title": "How can we help?",
    "help_grid": {
      "api_docs": {
        "title": "API Docs",
        "body": "Learn about the SparkLayer API and how to connect backend systems for more complex integrations."
      }
    },
    "faqs": {
      "title": "Partner FAQs",
      "partner_portal_link": "Click here to open the Partner Portal.",
      "invite_team": {
        "title": "How do I invite team members?",
        "body": {
          "text": "IIf you'd like to invite additional team members to your partner account, head over to the Team area to add and manage members.",
          "link": "Click here to go to the Team area."
        }
      },
      "refer": {
        "title": "How do I refer and manage my referred customers?",
        "body": {
          "text": "When you're ready to refer a customer, you'll need to sign into our partner portal where you can easily submit leads. Our team will then be in touch as soon as the lead has been reviewed and confirmed."
        }
      },
      "payouts": {
        "title": "How do referral payouts work?",
        "body": {
          "text": "Please refer to our partner portal for full details on how referrals and commissions work."
        }
      },
      "agreement": {
        "title": "Where can I find our partnership agreement?",
        "body": {
          "text": "Please refer to our partner portal to view and download your partnership agreement. "
        }
      }
    }
  }
}
